module.exports = __webpack_public_path__ + "images/chevrolet_smalldcfe6d9acc2a8644c978dae1a11229f1.png";